import { render, staticRenderFns } from "./CaseNumberSection.vue?vue&type=template&id=4e018d22&"
import script from "./CaseNumberSection.vue?vue&type=script&lang=js&"
export * from "./CaseNumberSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports